import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import * as moment from 'moment';
/* import * as JsBarcode from 'jsbarcode'; */
import { trigger, transition, style, animate } from '@angular/animations';

import { SmartListTransactionItem } from '@components/smart-list/GenericSmartList';
import { SessionModel } from '@models/SessionModel';
import { TransactionNotesModel } from '@models/TransactionModel';
import { VendorStoreModel } from '@models/VendorModel';
import { ApiTransactionService } from '@services/api-transaction.service';
import { SessionManager } from '@services/session-manager';
import { SharedService } from '@services/shared.service';

import { Country } from '@shared/models/Enums';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-events-details',
    templateUrl: './events-details.component.html',
    styleUrls: ['./events-details.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('10ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ]
})
export class EventsDetailsComponent implements OnInit {

    @Input() transactionEventId: number;
    @Input() country: Country = Country.CR;
    @Input() preloadedSale: SmartListTransactionItem = null;//receive the data to dont call the api again
    @Output() preloadSale: EventEmitter<SmartListTransactionItem> = new EventEmitter<SmartListTransactionItem>();// send the data to preload it in the next reload
    @Output() onUpdateTransactionNote: EventEmitter<TransactionNotesModel> = new EventEmitter<TransactionNotesModel>();

    sale: SmartListTransactionItem;

    vendorStores: VendorStoreModel[] = [];

    givilink: string;
    giviLinkOrigin: string;

    linkCopied = false;

    token = '';
    tokenTimerId = null;
    showBarcode: boolean = false;

    successRedeemId = null;

    currentTokenTimerMax = 18000;
    currentTokenTimerValue = 18000;

    showSuccess = false;

    // Note
    giviNote: TransactionNotesModel;
    transactionId: number;
    customerOwnerId: number;

    session: SessionModel;

    actionOption = 1; //1 = Qr, 2 = Barras, 3 = regalar, 4 = Download
    showMoreDetails = false;
    showDescription = false;

    wantToRedeem = false;
    isVisible = false;

    private wantToRedeemSubscription: Subscription = null;

    constructor(public location: Location,
        public router: Router,
        private route: ActivatedRoute,
        public sharedService: SharedService,
        private renderer: Renderer2,
        public apiTransactionService: ApiTransactionService,
        private modalService: NgbModal) {
    }

    ngOnInit(): void {

        this.session = SessionManager.getSession(true);

        //hide the qr code
        this.wantToRedeemSubscription = this.sharedService.wantToRedeemId.subscribe(x => {

            if (this.sale && this.sale.id != x) {

                clearInterval(this.tokenTimerId);
                clearInterval(this.successRedeemId);
                this.wantToRedeem = false;
            };
        });

        if (this.preloadedSale == null) this._getTransaction(this.transactionEventId);
        else {

            this.sale = new SmartListTransactionItem(this.preloadedSale);
            this._initLoad();
        }

    }

    ngOnDestroy() {

        if (this.wantToRedeemSubscription) { this.wantToRedeemSubscription.unsubscribe(); }

        clearInterval(this.successRedeemId);
        clearInterval(this.tokenTimerId);

    }

    onChangeWantToRedeem() {

        window.addEventListener('scroll', this.handleScroll);
        this.isVisible = true;

        this.sharedService.setWantToRedeemId(this.sale.id);

        this._refreshToken();
        this._successRedeemed();

        //interval each second for the crono
        this._updateCountdowns();
        setInterval(() => this._updateCountdowns(), 1000);

        this.wantToRedeem = true;

    }

    handleScroll = () => {

        const targetDiv = document.querySelector('#targetDiv') as HTMLElement;

        if (targetDiv) {

            const rect = targetDiv.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {

                this.isVisible = true;
            } else this.isVisible = false;
        }
    };

    onChangeOption(option) {

        this.actionOption = option;

        if (option == 1) this.showBarcode = false;
        if (option == 2) this.changeShowCode(true);
        if (option == 4) this._downloadQR();
    }

    changeShowCode(showBarcode: boolean) {

        this.showBarcode = showBarcode;

        if (showBarcode) {
            setTimeout(() => {
                const barcodeElement = this.renderer.selectRootElement('#barcode', true);
                if (barcodeElement) {
                    //barcode
                    /* JsBarcode(barcodeElement, `${this.sale.qrCode + '/' + this.token}`, {
                        format: "CODE128",
                        lineColor: "#000",
                        width: 2,
                        height: 150,
                        displayValue: true
                    }); */
                }
            }, 10);
        }
    }

    onCloseSuccess() {

        //close success redeemed
        this.showSuccess = false;

        let url = this.router.url;

        this.router.navigateByUrl('/market', { skipLocationChange: true }).then(() => {
            this.router.navigateByUrl(url);
        });
    }

    onViewTicket(ticketModal: any) {


        if (this.sale?.isLite || this.sale.allowDownload) {

            if (this.sale?.isLite) {

                this.modalService.open(ticketModal, {
                    backdrop: 'static', keyboard: false, scrollable: true,
                    centered: true, windowClass: 'modal-full'
                });

            } else {

                if (!this.sale.isLite && !this.sale.qrDownloadedAt) {

                    // Valida si es la primera ves
                    this.sharedService.showConfirmAlert(
                        `¿Estás seguro que deseás generar la captura del QR de tu entrada?`,
                        `* Una vez generado la entrada, no podrás regalarlo a otra persona.`
                    ).then(
                        (result: any) => {

                            if (result && result.value) {

                                this.sharedService.setLoading(true);

                                this.modalService.open(ticketModal, {
                                    backdrop: 'static', keyboard: false, scrollable: true,
                                    centered: true, windowClass: 'modal-full'
                                });

                                // Valida si ya se genero la primera ves
                                setTimeout(() => { this.onDownloadTicket(); this.sharedService.setLoading(false); }, 2000);
                            }
                        }
                    );
                }
                else {

                    this.modalService.open(ticketModal, {
                        backdrop: 'static', keyboard: false, scrollable: true,
                        centered: true, windowClass: 'modal-full'
                    });
                }
            }
        }

    }

    onDownloadTicket() {

        const element = document.getElementById('EvenTicketPreview'); // ID del elemento HTML a convertir
        if (!element) {
            console.error('Elemento no encontrado');
            return;
        }

        // Clonar el elemento para modificarlo
        const clonedElement = element.cloneNode(true) as HTMLElement;
        clonedElement.setAttribute('style', 'background-color: #1A1B27; padding: 20px; border-radius: 0');

        // Insertar el clon temporalmente en el DOM para capturarlo
        document.body.appendChild(clonedElement);
        clonedElement.style.position = 'absolute';
        clonedElement.style.left = '-9999px'; // Moverlo fuera de la vista

        html2canvas(clonedElement, {
            useCORS: true, // Habilitar soporte CORS
            allowTaint: false, // Evita tainting del canvas (si no se necesita)
            imageTimeout: 5000, // Ajusta el tiempo de espera
            backgroundColor: null, // Opcional, para un fondo transparente
        }).then((canvas) => {
            // Convertir el canvas a una imagen en formato PNG
            const image = canvas.toDataURL('image/png');

            // Crear un enlace de descarga
            const link = document.createElement('a');
            link.href = image;
            link.download = `${this.sale.ticket.eventObj.name}-${this.sale.ticket.name}.png`;
            link.click();

            this._updateQrDownload();

            // Eliminar el clon después de la captura
            document.body.removeChild(clonedElement);
        }).catch(error => {
            console.error('Error al generar la imagen:', error);
            // Eliminar el clon después de la captura
            document.body.removeChild(clonedElement);
        });
    }

    onSendEmailTicket() {

        if (this.sale?.isLite || this.sale.allowDownload) {

            if (this.sale?.isLite) {

                this._sendEmailTicket();
            } else {

                this.sharedService.showConfirmAlert(
                    `¿Estás seguro que deseás enviar tu entrada por correo electrónico?`,
                    `* Una vez enviada la entrada por correo electrónico, no podrás regalarlo a otra persona.`
                ).then(
                    (result: any) => {

                        if (result && result.value) {

                            this._sendEmailTicket();
                        }
                    }
                );
            }
        }
    }

    showGiviNote(transactionNote: TransactionNotesModel, transactionId: number, customerOwnerId: number, isExpired: boolean) {

        if (!isExpired) {
            this.giviNote = transactionNote;
            this.transactionId = transactionId;
            this.customerOwnerId = customerOwnerId;
            this.sharedService.setShowGiviNoteModalModal(true);
        }
    }

    onUpdateNote(transactionNote: TransactionNotesModel) {

        this.sale.transactionNotes = transactionNote;
        this.onUpdateTransactionNote.emit(transactionNote);
    }

    infoOpen(subtitle, text) {

        let title = 'Descripción del ticket'
        this.sharedService.showInfoTicketsAlert(title, subtitle, text, false)
    }


    private _getTransaction(id: number): void {

        this.apiTransactionService.getFullTransaction(id, this.country).then(
            (transaction) => {

                this.sale = new SmartListTransactionItem({
                    userId: id,
                    ...transaction
                });

                if (this.sale.allowDownload) {
                    // Convierte el url de la imagen a base64
                    this.sharedService.convertToBase64(this.sale.ticket.productImageAssociate)
                        .then((base64) => {
                            this.sale.ticket.imageToBase64 = base64;
                        });
                }

                this.sale.country = this.country;

                this.preloadSale.emit(this.sale);

                this._initLoad();
            },
            (err) => {

                this.sharedService.setLoading(false);

                let errMsg = `Error al cargar información del Ticket`;
                if (err.status == 404) {
                    errMsg = `El Ticket no existe`;
                }
                // Desautorizado navigate to login
                else if (err.status == 401 || err.message?.indexOf('caducado') >= 0) {

                    this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(() => {
                        this.router.navigate(['/market']);
                    });
                    return;
                }
                this.sharedService.showErrorAlert(null, errMsg).then(_x => {

                    //reaload
                    let url = this.router.url;

                    this.router.navigateByUrl('/market', { skipLocationChange: true }).then(() => {
                        this.router.navigateByUrl(url);
                    });
                });
            }
        );
    }

    private _initLoad() {

        this.vendorStores = this.sale.productStores?.filter(x => x.deletedAt == null);

        this._genLink();
    }

    private _genLink() {

        const code = `tk-${this.sale.id.toString().padStart(5, '0')}-${this.sale.customerOwnerId}`;
        let hash = window.btoa(code);

        // Remove the = symbol
        hash = hash.replace(/[=]/g, '');

        let text = `comercio=${this.sale.vendorName}`;
        // Remove the % symbol
        text = text.replace(/[%]/g, '');
        // Replace the spaces
        text = text.replace(/\s/g, '+');

        this.givilink = `${this.apiTransactionService.siteUrl}/tt/${this.session?.user?.country}/${hash}?${text}`;
        this.giviLinkOrigin = this.givilink;
        this.givilink = `${this.giviLinkOrigin}`;
    }

    private _updateCountdowns() {

        if (this.sale.ticket && this.sale.ticket.eventObj && !this.sale.ticket.eventObj.readyToRedeem) {

            //function to create the crono using the lib moment
            this.sale.ticket.eventObj.timeToReadyToRedeem = moment(this.sale.ticket.eventObj.startDateAt);
            const timeDifference = this.sale.ticket.eventObj.timeToReadyToRedeem.diff(moment());

            //if the timeToReadyToRedeem  is other we validate the hours.
            if (timeDifference > 0) {

                const duration = moment.duration(timeDifference);
                const totalDays = duration.months() * 30 + duration.days();

                if (totalDays > 0) {
                    this.sale.ticket.eventObj.readyToRedeemTimeText = `${totalDays}d : ${duration.hours()}h : ${duration.minutes()}m`;
                } else {
                    this.sale.ticket.eventObj.readyToRedeemTimeText = `${duration.hours()}h : ${duration.minutes()}m : ${duration.seconds()}s`;
                }
            }
        }
    }

    private _updateQrDownload() {

        if (this.sale?.isEvent && !this.sale.qrDownloadedAt) {

            this.apiTransactionService.updateQRDownload(this.sale, this.country).then(
                (transaction) => {

                    this.sale.qrDownloadedAt = transaction.qrDownloadedAt;

                    this.preloadSale.emit(this.sale);
                }
            );
        }
    }

    private _sendEmailTicket() {

        this.apiTransactionService.sendEmailTicket(this.sale.id, this.country).then(
            (transaction) => {

                this.sale.qrDownloadedAt = transaction.qrDownloadedAt;

                this.sharedService.showSuccessAlert('¡Revisá tu correo electrónico!',
                    'Te hemos enviado tu entrada l correo, tomale un pantallazo para mostrarla el día del evento.');

                this.preloadSale.emit(this.sale);
            }
        );
    }

    private _successRedeemed() {

        //check if the givi has been redeemedx

        this.successRedeemId = setInterval(() => {

            if (this.sale.redeemedAt === null && this.isVisible) {

                this.apiTransactionService.getBasicTransaction(this.sale.id, this.country).then(
                    (transaction) => {

                        //if the givi is actually redemeed we show a success modal 
                        //and stop de the interval
                        if (transaction.redeemedAt != null) {

                            clearInterval(this.successRedeemId);

                            this.showSuccess = true;
                        }
                    }
                )
            }
        }, 1000);
    }

    private _refreshToken() {

        // Calcular el timer
        this.currentTokenTimerMax = 5 * 60 * 60; // 5min to Seconds

        // First token
        let tokenData = this.apiTransactionService.getToken(this.sale?.id, this.currentTokenTimerMax);
        this.currentTokenTimerValue = tokenData.currentTokenTimerValue;
        this.token = tokenData.token;

        // Refresh token each 1 second
        this.tokenTimerId = setInterval(() => {

            tokenData = this.apiTransactionService.getToken(this.sale?.id, this.currentTokenTimerMax);
            this.currentTokenTimerValue = tokenData.currentTokenTimerValue;
            this.token = tokenData.token;
        }, 100);
    }

    private _downloadQR() {

        const codeElement = document.getElementById('EventTicketQR'); // ID del elemento HTML a convertir
        if (!codeElement) {
            console.error('Elemento no encontrado');
            return;
        }

        html2canvas(codeElement, {
            useCORS: true, // Habilitar soporte CORS
            allowTaint: false, // Evita tainting del canvas (si no se necesita)
            imageTimeout: 5000, // Ajusta el tiempo de espera
            backgroundColor: null, // Opcional, para un fondo transparente
        }).then((canvas) => {
            // Convertir el canvas a una imagen en formato PNG
            const image = canvas.toDataURL('image/png');

            // Crear un enlace de descarga
            const link = document.createElement('a');
            link.href = image;
            link.download = `${this.sale.ticket.eventObj.name}-${this.sale.ticket.name}.png`;
            link.click();
        }).catch(error => {
            console.error('Error al generar la imagen:', error);
        });
    }
}
